import customAxios from "./axiosConfig";

const CostTypeService = {
  list: function (params) {
    var api_url = window.Urls['costtype-list']();
    return customAxios.get(api_url, { params: params });
  },
  create: function (costtype) {
    var api_url = window.Urls['costtype-list']();
    const config = {
        headers: { 'content-type': 'multipart/form-data' },
    };
    const getFormData = object => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
    return customAxios.post(api_url, getFormData(costtype), config)
  },
  update: function (costtype) {
    costtype = this._cleanCostType(costtype);
    var api_url = window.Urls['costtype-detail'](costtype.id);
    const config = {
        headers: { 'content-type': 'multipart/form-data' },
    };
    const getFormData = object => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
    return customAxios.put(api_url, getFormData(costtype), config).then(function(success){
      var data = success.data;
      if (window.mixpanel) {
        window.mixpanel.track("CostType: update", {
          "name": data.name,
          "group": data.group,
          "company": data.company,
          "icon": data.icon,
          "vat deductible": data.vat_deductible,
          "archived": data.archived
        });
      }
      return success;
    });
  },
  spanishLedgerOptions: function(){
    var api_url = window.Urls["costtype_ledger_options"]();
    return customAxios.get(api_url);
  },
  _cleanCostType: function(costtype){
    if(costtype.group===null){
        delete costtype.group;
    }
    if(costtype.ledger_category===null){
        delete costtype.ledger_category;
    }
    return costtype;
  },
  prepareDataForUpdate: function(costtype) {
    let data = JSON.parse(JSON.stringify(costtype));

    if (data.is_balance_sheet)
        data.is_balance_sheet = "True";
    else
        data.is_balance_sheet = "False";
    
    if (data.vat_deductible)
        data.vat_deductible = "True";
    else
      data.vat_deductible = "False";
    
    if (data.archived)
        data.archived = "True";
    else
      data.archived = "False";

    if (data.is_default)
        data.is_default = "True";
    else
      data.is_default = "False";
    
    return data;
  },
  getCostCategoriesForReport(params) {
    let api_url = window.Urls['costtype_get_cost_categories_for_report']()
    return customAxios.get(api_url, {params: params})
  },
  ExportDetailsCSV(params){
    let api_url = window.Urls['costtype_export_details_csv']()
    return customAxios.get(api_url, {params: params})
  }
};

export default CostTypeService;